export enum FoveaHostKind {
	CUSTOM_ELEMENT = "custom-element",
	CUSTOM_ATTRIBUTE = "custom-attribute"
}